import React from 'react';
import ReactDOM, { Root } from 'react-dom/client';
import { Spin } from 'antd';
import { SpinProps } from 'antd/es/spin';

import { isHidden } from '@/utils';

import './index.scss';

export const Loading: React.FC<SpinProps> = props => (
  <div className="global-loading">
    <Spin size="large" tip="数据加载中..." {...props} wrapperClassName="w-full">
      <div className="content" />
    </Spin>
  </div>
);

let dom: HTMLElement | null;
let instance: Root | null;
const GlobalLoading = {
  open(props: SpinProps = {}): void {
    if (!dom) {
      dom = document.createElement('div');
      instance = ReactDOM.createRoot(dom);
      instance.render(<Loading {...props} />);
      document.body.appendChild(dom);
    }
    if (isHidden(dom)) {
      dom.style.display = '';
    }
  },
  close(): void {
    dom!.style.display = 'none';
  },
  remove(): void {
    instance?.unmount();
    dom && document.body.removeChild(dom!);
    dom = null;
  },
};

export default GlobalLoading;
